export default __webpack_public_path__ + "static/media/SXP.bbf13d30.svg";